import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ResultsSection() {
  const results = ['Bajar de peso de forma progresiva', 'Reducir abdomen', 'Tonificar tu cuerpo', 'Tener más energía', 'Volver a sentirte segura'];
  return <section className="py-8 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-282">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="bg-pink-50/50 border border-pink-200 rounded-3xl p-8 md:p-10 shadow-sm relative overflow-hidden" data-id="element-283">
        <div className="absolute top-0 right-0 w-40 h-40 bg-emerald-50 blur-[60px] rounded-full pointer-events-none" data-id="element-284" />

        <div className="text-center mb-8 relative z-10" data-id="element-285">
          <h2 className="font-display text-2xl md:text-3xl font-bold text-gray-900 flex items-center justify-center gap-2" data-id="element-286">
            <span data-id="element-287">✨</span> Con este sistema vas a lograr:
          </h2>
        </div>

        <ul className="space-y-4 max-w-md mx-auto mb-8 relative z-10" data-id="element-288">
          {results.map((result, i) => <motion.li key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-center gap-3 text-lg md:text-xl text-gray-700 font-medium bg-white/80 p-3 rounded-xl border border-pink-100" data-id="element-289">
              <CheckCircle2 size={24} className="text-brand-success flex-shrink-0" data-id="element-290" />
              <span data-id="element-291">{result}</span>
            </motion.li>)}
        </ul>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-center relative z-10" data-id="element-292">
          <p className="text-xl md:text-2xl font-bold text-brand-accent" data-id="element-293">
            👉 Sin dejar de ser mamá ni vivir entrenando
          </p>
        </motion.div>
      </motion.div>
    </section>;
}